import {Injectable} from '@angular/core';
import {UserService} from '../../services/user.service';
import {LanguageSwitcher} from '../../header/language-switcher/language-switcher.model';
import {HeaderService} from '../../services/header.service';
import {TaskBarService} from '../../services/task-bar.service';
import {SidebarService} from '../../services/side-bar.service';

@Injectable()
export class StandardTestingLayout {
  constructor(private sidebar: SidebarService, private taskbar: TaskBarService, private header: HeaderService) {}

  apply(): void {
    this.sidebar.closeSideBar();
    this.taskbar.closeTaskBar();
    this.header.hideSideMenu();
    this.header.hideTaskMenu();
    this.header.hideUsername();
  }
}

@Injectable()
export class PhoneStandardsContext {
  constructor(public userService: UserService, public language: LanguageSwitcher, public testingLayout: StandardTestingLayout) {}
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-standards/phone-standards-context.ts